/* eslint-disable max-len */
import React from 'react';

const InsertPluginIcon = props => (
  <svg
    width="19px"
    height="12px"
    viewBox="0 0 23 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-265.000000, -379.000000)" fill="currentColor">
        <g transform="translate(265.000000, 379.000000)">
          <path
            d="M10,0.8 L22.6,0.8 C22.7104569,0.8 22.8,0.88954305 22.8,1 L22.8,1.6 C22.8,1.71045695 22.7104569,1.8 22.6,1.8 L10,1.8 C9.88954305,1.8 9.8,1.71045695 9.8,1.6 L9.8,1 C9.8,0.88954305 9.88954305,0.8 10,0.8 Z M10,5.8 L22.6,5.8 C22.7104569,5.8 22.8,5.88954305 22.8,6 L22.8,6.6 C22.8,6.71045695 22.7104569,6.8 22.6,6.8 L10,6.8 C9.88954305,6.8 9.8,6.71045695 9.8,6.6 L9.8,6 C9.8,5.88954305 9.88954305,5.8 10,5.8 Z M10,10.8 L22.6,10.8 C22.7104569,10.8 22.8,10.8895431 22.8,11 L22.8,11.6 C22.8,11.7104569 22.7104569,11.8 22.6,11.8 L10,11.8 C9.88954305,11.8 9.8,11.7104569 9.8,11.6 L9.8,11 C9.8,10.8895431 9.88954305,10.8 10,10.8 Z"
            fillRule="nonzero"
          />
          <path
            d="M2.61252587,5.04452587 C2.55011987,5.10656164 2.44933186,5.10656164 2.38692587,5.04452587 L2.04692587,4.70452587 C2.01688154,4.67451494 2,4.63379134 2,4.59132587 C2,4.54886039 2.01688154,4.50813679 2.04692587,4.47812587 L4.47972587,2.04532587 L2.04772587,-0.386674135 C2.01768154,-0.416685056 2.0008,-0.457408655 2.0008,-0.499874135 C2.0008,-0.542339615 2.01768154,-0.583063214 2.04772587,-0.613074135 L2.38692587,-0.953074135 C2.41693679,-0.983118462 2.45766039,-1 2.50012587,-1 C2.54259134,-1 2.58331494,-0.983118462 2.61332587,-0.953074135 L5.49812587,1.93172587 C5.52817019,1.96173679 5.54505173,2.00246039 5.54505173,2.04492587 C5.54505173,2.08739134 5.52817019,2.12811494 5.49812587,2.15812587 L2.61252587,5.04372587 L2.61252587,5.04452587 Z"
            transform="translate(3.772526, 2.045526) rotate(-270.000000) translate(-3.772526, -2.045526) "
          />
        </g>
      </g>
    </g>
  </svg>
);

export default InsertPluginIcon;
